import styled from 'styled-components';
import Input from '../Input';
import Button from '../Button';
import CheckboxInput from '../Checkbox/CheckboxInput';
// import Checkbox from '../Checkbox';

// @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
//   display:none;
// };
const ListStyle = styled.div`
    background: ${(props) => props.theme.tintGray};
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
      width: 100%;
      background:${(props) => props.theme.whiteColor}; 
    };
  ${Input}{
      padding: 7px;
      width: 100%;
      font-size: 14px;
    }

    h1{
      font-size: 18px;
      padding: 10px;
      margin: 0;
      color: #999;
      background:${(props) => props.theme.whiteColor};
    }
    hr{
      border:${(props) => props.theme.lightWhite} solid 1px;
      margin:0px;
    }
  ul{
    list-style:none;
    margin:0px;
    padding:0px;  
    background:${(props) => props.theme.whiteColor};  
    h1{
      font-size:16px;
      width:100%;
      padding: 10px;
      margin:0px;
      color: ${(props) => props.theme.secondaryColor};
    }
    li{
      display:inline-block;
      width:100%;
      padding: 8px 8px 0px;
      cursor: pointer;
      &:last-child{
        padding:8px 8px 0px;
        position: relative;
        
        hr{
          display:none;
        }
      }
      ${CheckboxInput}{
        label{
          &::before{
            border-radius: 4px;
            border: 1px solid ${(props) => props.theme.mystic};
          }
        }
      }
      a{
        text-decoration:none;
        color:${(props) => props.theme.secondaryColor};
        font-size:12px;
      }
      label{
        cursor: pointer;
        float: left;
        width: 93%;
        &:before{
          float:left
        }
        
      }
      input[type=checkbox]:checked + label {
        font-weight:bold;
        strong{
          font-weight:bold;
        }
      } 
      input[type=checkbox]{
        
      }
      strong{
        width:75%;
        padding-left:5px;
        font-weight:normal;
        font-size:14px;
        display:inline-block;
      }
      span{
        float:right;
        font-size:14px;
        color: #999;
        font-weight:bold;
      }
      .fa-plus{
        margin-top: 4px;
      }
      ul{
        padding: 8px 0px;
        li{
          padding-left:25px;
          &:last-child{
            padding-left:25px;
          }
        }
      }
    }
  }
`;

const MobileListStyle = styled.div`
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
    display:none;
    };
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      display:block;
    };
    ${ListStyle} {
      background: none;
      border: none;
    }
    .header{
      padding: 20px;
      border-bottom:${(props) => props.theme.lightGray} solid 1px;
      small{
        font-size: 30px;
        font-weight: 600;
      }
      .close{
        float: right;
        background: ${(props) => props.theme.LandingBlack};
        width: 32px;
        height: 32px;
        color: ${(props) => props.theme.whiteColor};
        border-radius: 50%;
        text-align: center;
        line-height: 31px;
        cursor: pointer;
        margin-top:10px;
      }
    }
    .wrapperFlex{
      display: flex;
    }
  .left{
    width:35%;
    ul{
      margin:0px;
      padding:0px;
      list-style:none;
      li{
        display:block;
        padding:20px 10px 20px 20px;
        border:${(props) => props.theme.lightGray} solid 1px;
        border-top:none;
        border-left:none;
        cursor: pointer;
        text-transform: uppercase;
        &.active{
          border-right:none;
          background:${(props) => props.theme.lightWhite};
          font-weight: 600;
        }
      }
    }
  }
  .right{
    width:64%;
    height:550px;
    overflow:auto;
    background:${(props) => props.theme.lightWhite};
    ul{
      margin:0px;
      padding:0px;
      list-style:none;
      background: none;
      li{
        display:block;
        margin: 6px 10px;
        ${CheckboxInput}{
          width: 85%;
          label{
            &::before{
              border-radius: 4px;
              border: 1px solid ${(props) => props.theme.mystic};
            }
          }
        }
        input[type=checkbox]:checked + label {
          font-weight:bold;
          strong{
            font-weight:bold;
          }
        }
        strong{
          font-weight:normal;
          margin-left:10px;
        }
        span{
          margin-left:10px;
          &:after{
            content: ')';
          }
          &:before{
            content: '(';
          }
        }
        ${ListStyle}{
          padding-bottom: 20px;
          h1{
            background: none;
            padding: 0px;
          }
        }
      }
    }
  }
  ${Button}{
    width:100%;
    position:fixed;
    bottom:0;
    display: block;
  }
`;


export { ListStyle, MobileListStyle };



// WEBPACK FOOTER //
// client/components/ListFilters/StyledListFilters.js